import React from 'react';
import PropTypes from 'prop-types';

const STATUS_CONFIG = {
  SENT: { label: '\u2713 Email Sent', className: 'email-badge-success' },
  FAILED: { label: '\u2717 Email Failed', className: 'email-badge-danger' },
  PENDING: { label: '\u23F3 Pending', className: 'email-badge-warning' },
};

const EmailStatusBadge = ({ status }) => {
  const { label, className } = STATUS_CONFIG[status] || STATUS_CONFIG.PENDING;

  return <span className={`email-status-badge ${className}`}>{label}</span>;
};

EmailStatusBadge.propTypes = {
  status: PropTypes.oneOf(['SENT', 'FAILED', 'PENDING']),
};

EmailStatusBadge.defaultProps = {
  status: 'PENDING',
};

export default EmailStatusBadge;
